import { useEffect } from "react"
import AOS from "aos"
import "aos/dist/aos.css"
import "./ContactPage.css"

function ContactPage(){

useEffect(()=>{
AOS.init({duration:1000, once:true})
},[])

return(

<div className="contactPage">

{/* HERO */}

<section
className="contactHero"
style={{backgroundImage:"url(/images/about-banner.png)"}}
>

<div className="contactHeroOverlay">

<h1>Contact LaceGota</h1>

<p>
We are always happy to help boutique designers,
fashion houses and wholesale partners.
</p>

</div>

</section>


{/* CONTACT INFO */}

<section className="contactInfo">

<h2 data-aos="fade-up">Get In Touch</h2>

<div className="contactGrid">

<div className="contactCard" data-aos="fade-up">

<h3>📍 Address</h3>

<p>
S.G.T.B Company <br/>
5512, Gandhi Market <br/>
Sadar Bazar, North Delhi <br/>
Delhi – 110006
</p>

</div>


<div className="contactCard" data-aos="fade-up">

<h3>📞 Phone</h3>

<p>
<a href="tel:8287691638">
8287691638
</a>
</p>

<p>Available Mon – Sat</p>

</div>


<div className="contactCard" data-aos="fade-up">

<h3>📧 Email</h3>

<p>
<a href="mailto:sgtbofficial5@gmail.com">
sgtbofficial5@gmail.com
</a>
</p>

<p>We reply within 24 hours</p>

</div>

</div>

</section>


{/* CONTACT FORM */}

<section className="contactFormSection">

<div className="contactFormContainer">

<div className="contactFormText">

<h2 data-aos="fade-right">
Send us a Message
</h2>

<p data-aos="fade-right">
If you have questions about lace trims,
gota patti materials or wholesale orders,
feel free to contact us.
</p>

</div>


<form className="contactForm" data-aos="fade-left">

<input type="text" placeholder="Your Name" required/>

<input type="email" placeholder="Your Email" required/>

<input type="text" placeholder="Subject"/>

<textarea
placeholder="Your Message"
rows="5"
required
></textarea>

<button type="submit">
Send Message
</button>

</form>

</div>

</section>


{/* GOOGLE MAP */}

<section className="mapSection">

<h2>Visit Our Store</h2>

<div className="mapContainer">

<iframe
title="map"
src="https://maps.google.com/maps?q=Gandhi%20Market%20Sadar%20Bazar%20Delhi&t=&z=15&ie=UTF8&iwloc=&output=embed"
loading="lazy"
></iframe>

</div>

</section>


{/* FLOATING BUTTONS */}

<a
href="https://wa.me/918287691638"
className="whatsappBtn"
target="_blank"
rel="noreferrer"
>
💬
</a>

<a
href="tel:8287691638"
className="callBtn"
>
📞
</a>

</div>

)

}

export default ContactPage